import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL;

const Api = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }
})

export default Api;